import { Tabs } from '@delmonicos/shared-design-system-react/src/components/tab/tabs.component';
import {
  extractTabKeys,
  useTabQuery,
} from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/hooks';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { LocationChargePointListControllerWithContext } from '../location-charge-point-list/location-charge-point-list.controller';
import { LocationInformationView } from './location-information/location-information.view';

enum TabsEnum {
  information = 'information',
  chargePoints = 'chargePoints',
}

export const LocationDetailsView = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  // Nothing to do

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // TABS //////////////////////////////////////////////////////////////////////

  const tabs = useMemo(
    () =>
      [
        {
          title: t('$.location-details.information.title'),
          key: TabsEnum.information,
          icon: 'info-circle',
        },
        {
          title: t('$.charge-point-list.title'),
          key: TabsEnum.chargePoints,
          icon: 'electric-terminal',
        },
      ] as const,
    [t],
  );

  const { tab: currentTab, setTab: setCurrentTab } = useTabQuery(
    TabsEnum.information,
    extractTabKeys(tabs),
  );

  // HANDLERS //////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <>
      <Tabs
        currentTab={currentTab}
        onTabClick={(tab) => setCurrentTab(tab)}
        elements={tabs}
      />
      {currentTab === TabsEnum.information && <LocationInformationView />}
      {currentTab === TabsEnum.chargePoints && (
        <LocationChargePointListControllerWithContext />
      )}
    </>
  );
};
